import React from 'react';
import {PricingTable, PricingSlot, PricingDetail} from 'react-pricing-table';

export default function FeesComparision(){

    return(
      <div class='fees-comp'>
        <div class="comparison-container">
          
            <div class="header-row">
                <div class="header-cell"></div>
                <div class="header-cell">Other Online Tuitions</div>
                <div class="header-cell">Home Tuitions</div>
                <div class="header-cell">TeacherInd</div>
            </div>

            <div class="data-row">
                <div class="data-cell">Progress Tracker</div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
            </div>
            
            <div class="data-row">
                <div class="data-cell">One Student. One Teacher</div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
            </div>
            
            <div class="data-row">
                <div class="data-cell">Flexible Timings</div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
            </div>
            
            <div class="data-row">
                <div class="data-cell">Custom Unit Exams</div>
                <div class="data-cell"><span class="check">✔</span></div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
            </div>
            
            <div class="data-row">
                <div class="data-cell">Growth Sessions</div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
            </div>
            
            <div class="data-row">
                <div class="data-cell">TI Exam Tool</div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
            </div>
            
            <div class="data-row">
                <div class="data-cell">Custom Study Time Table</div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="cross">✘</span></div>
                <div class="data-cell"><span class="check">✔</span></div>
            </div>
        </div>
        
        <div class='tution-fee-button'>
            <a class="state_book_button" href="/form">Check Tuition Fees</a>
        </div>
    </div>)
}